import React from 'react';
import { bool } from 'prop-types';
import { Row, Loader } from '@thd-olt-component-react/core-ui';
import './loader-overlay.scss';

export const LoaderOverlay = ({ isLoading }) => {
  return (
    <Row className={`loader-overlay__wrapper-${isLoading}`} data-testid="loader" data-component="ProductSetLoader">
      <Loader
        className="loader-overlay__loader"
        active={isLoading}
      />
    </Row>
  );
};

LoaderOverlay.propTypes = {
  isLoading: bool.isRequired
};
